import { makeStyles } from '@material-ui/core/styles';
import { redesignTheme } from '../../../../theme';

const { colors, spacing } = redesignTheme;

export const usePreferenceContentStyles = makeStyles({
  validation: {
    display: 'flex',
    alignItems: 'center',
    gap: spacing.xs,
    color: colors.primaryDark,
    fontSize: 14,
    margin: 0,
    '& svg': { width: 20, height: 20, flexShrink: 0 },
  },
  axis: {
    '& [class*="MuiSlider-root"]': { color: 'inherit !important' },
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: spacing.xs,
    marginTop: spacing.md,
    '& button': { borderRadius: 50 },
  },
  description: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.md,
  },
  hint: { fontStyle: 'italic', marginBottom: 0 },
  editActions: { display: 'flex', justifyContent: 'flex-end', gap: spacing.xs },
});
